// extracted by mini-css-extract-plugin
export default {"base":"mqB_9","secondary":"S7ulh","flat":"G4_vg","disabled":"YOJgL","mini":"fO81E"};